import {
	Body1 as MDCBody1,
	Body2 as MDCBody2,
	Button as MDCButton,
	Caption as MDCCaption,
	Headline1 as MDCHeadline1,
	Headline2 as MDCHeadline2,
	Headline3 as MDCHeadline3,
	Headline4 as MDCHeadline4,
	Headline5 as MDCHeadline5,
	Headline6 as MDCHeadline6,
	Overline as MDCOverline,
	Subtitle1 as MDCSubtitle1,
	Subtitle2 as MDCSubtitle2,
} from '@material/react-typography';
import PropTypes from 'prop-types';

import classes from './Typography.module.scss';

const STYLE_BODY_1 = 'mdc-typography--body1';
const STYLE_BODY_2 = 'mdc-typography--body2';
const STYLE_BUTTON = 'mdc-typography--button';
const STYLE_CAPTION = 'mdc-typography--caption';
const STYLE_HEADLINE_1 = 'mdc-typography--headline1';
const STYLE_HEADLINE_2 = 'mdc-typography--headline2';
const STYLE_HEADLINE_3 = 'mdc-typography--headline3';
const STYLE_HEADLINE_4 = 'mdc-typography--headline4';
const STYLE_HEADLINE_5 = 'mdc-typography--headline5';
const STYLE_HEADLINE_6 = 'mdc-typography--headline6';
const STYLE_OVERLINE = 'mdc-typography--overline';
const STYLE_SUBTITLE_1 = 'mdc-typography--subtitle1';
const STYLE_SUBTITLE_2 = 'mdc-typography--subtitle2';

const Body1 = props => (
	<MDCBody1
		{...props}
		className={[props.className, classes[STYLE_BODY_1]].join(' ')}
	>
		{props.children}
	</MDCBody1>
);
const Body2 = props => (
	<MDCBody2
		{...props}
		className={[props.className, classes[STYLE_BODY_2]].join(' ')}
	>
		{props.children}
	</MDCBody2>
);
const TypButton = props => (
	<MDCButton
		{...props}
		className={[props.className, classes[STYLE_BUTTON]].join(' ')}
	>
		{props.children}
	</MDCButton>
);
const Caption = props => (
	<MDCCaption
		{...props}
		className={[props.className, classes[STYLE_CAPTION]].join(' ')}
	>
		{props.children}
	</MDCCaption>
);
const Headline1 = props => (
	<MDCHeadline1
		{...props}
		className={[props.className, classes[STYLE_HEADLINE_1]].join(' ')}
	>
		{props.children}
	</MDCHeadline1>
);
const Headline2 = props => (
	<MDCHeadline2
		{...props}
		className={[props.className, classes[STYLE_HEADLINE_2]].join(' ')}
	>
		{props.children}
	</MDCHeadline2>
);
const Headline3 = props => (
	<MDCHeadline3
		{...props}
		className={[props.className, classes[STYLE_HEADLINE_3]].join(' ')}
	>
		{props.children}
	</MDCHeadline3>
);
const Headline4 = props => (
	<MDCHeadline4
		{...props}
		className={[props.className, classes[STYLE_HEADLINE_4]].join(' ')}
	>
		{props.children}
	</MDCHeadline4>
);
const Headline5 = props => (
	<MDCHeadline5
		{...props}
		className={[props.className, classes[STYLE_HEADLINE_5]].join(' ')}
	>
		{props.children}
	</MDCHeadline5>
);
const Headline6 = props => (
	<MDCHeadline6
		{...props}
		className={[props.className, classes[STYLE_HEADLINE_6]].join(' ')}
	>
		{props.children}
	</MDCHeadline6>
);
const Overline = props => (
	<MDCOverline
		{...props}
		className={[props.className, classes[STYLE_OVERLINE]].join(' ')}
	>
		{props.children}
	</MDCOverline>
);
const Subtitle1 = props => (
	<MDCSubtitle1
		{...props}
		className={[props.className, classes[STYLE_SUBTITLE_1]].join(' ')}
	>
		{props.children}
	</MDCSubtitle1>
);
const Subtitle2 = props => (
	<MDCSubtitle2
		{...props}
		className={[props.className, classes[STYLE_SUBTITLE_2]].join(' ')}
	>
		{props.children}
	</MDCSubtitle2>
);

const props = {
	children: PropTypes.node,
	className: PropTypes.string,
	style: PropTypes.object,
	tag: PropTypes.string,
};

Body1.propTypes = props;
Body2.propTypes = props;
TypButton.propTypes = props;
Caption.propTypes = props;
Headline1.propTypes = props;
Headline2.propTypes = props;
Headline3.prototype = props;
Headline4.propTypes = props;
Headline5.propTypes = props;
Headline6.propTypes = props;
Overline.propTypes = props;
Subtitle1.propTypes = props;
Subtitle2.propTypes = props;

export {
	Body1,
	Body2,
	TypButton,
	Caption,
	Headline1,
	Headline2,
	Headline3,
	Headline4,
	Headline5,
	Headline6,
	Overline,
	Subtitle1,
	Subtitle2,
};
